import { jsxs as u, jsx as e } from "react/jsx-runtime";
import { useState as D } from "react";
import { DealImageWrapper as I, DealImageContainer as c, ImageComponent as x } from "./style.js";
import { DealImageSkeletonContainer as W } from "./style.js";
import { DealImageBadge as b } from "../DealImageBadge/index.js";
import { useTranslation as S } from "../../../hooks/useTranslation/index.js";
function v({
  src: o,
  alt: t,
  className: m,
  errorImage: l,
  inactiveLabel: n,
  isInactive: r,
  onClick: a,
  fetchPriority: i,
  placeholderImage: s,
  ...g
}) {
  const [d, p] = D(!1), { t: f } = S("common");
  return /* @__PURE__ */ u(I, { children: [
    /* @__PURE__ */ e(
      c,
      {
        "data-error": d,
        "data-isinactive": r,
        onClick: a,
        className: m,
        role: a ? "button" : "div",
        ...g,
        children: /* @__PURE__ */ e(
          x,
          {
            src: o,
            alt: t || f("deal-image-alt-text"),
            onError: () => p(!0),
            errorImage: l,
            placeholderImage: s,
            "aria-disabled": !1,
            loading: "eager",
            fetchPriority: i
          }
        )
      }
    ),
    r && /* @__PURE__ */ e(b, { label: n })
  ] });
}
export {
  v as DealImage,
  W as DealImageSkeleton
};
